import React from 'react';
import { Typography } from 'ui-v2/components/Typography';
import s from './OverallRating.module.scss';
import { ProductRating } from '../../types/review';
import AddRating from './AddRating';
import Icon from 'ui-v2/components/Icon/Icon';

type overallRatinProptype = {
  ratingData: ProductRating;
  product?: {
    title: string;
    subtitle: string;
    imgUrl: string;
    sku: string;
    id: number;
  };
  showAdd?: boolean;
  hideAdd?: () => void;
};

export const OverallRating = ({
  ratingData,
  product,
  showAdd,
  hideAdd,
}: overallRatinProptype) => {
  if (!ratingData?.avgRating) {
    if (showAdd)
      return (
        <div className={s.noRating}>
          <Typography
            label="Be the first one to review"
            variant="body_3_medium"
          />
          {<AddRating data={product} hideAdd={hideAdd} />}
        </div>
      );
    else return <></>;
  }
  return (
    <div className={s.rating}>
      <div className={s.overall}>
        <Typography
          label="Overall Rating"
          variant="label_3_medium"
          color="tertiary"
        />
        <div className={s.avg}>
          <Typography label={ratingData?.avgRating} variant="title_1_bold" />
          <Icon name="StarBold" color="positive" width={32} height={32} />
        </div>
        {showAdd && <AddRating data={product} hideAdd={hideAdd} />}
      </div>
      <div className={s.distribution}>
        {ratingData?.data?.map((item, index) => (
          <div key={index} className={s.item}>
            <Typography
              label={item?.rating}
              variant="body_4_medium"
              color="tertiary"
            />
            <div className={s.line}>
              <div
                className={s.progress}
                style={{
                  width: `${item?.percent}%`,
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
